import cn from 'classnames';
import { FC } from 'react';
import { Typography } from 'src/components/common/Typography';
import { useI18n } from 'src/hooks/use-i18n-translation';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    text: { [key: string]: string };
  };
};
const LegalNotice: FC<Props> = ({ settings }) => {
  const { text } = settings;

  const { locale } = useI18n();

  return (
    <div className={cn('legalNotice_container')}>
      <Typography className="label" variant={'h6'}>
        {text?.[locale]}
      </Typography>
    </div>
  );
};
export default LegalNotice;
